import React, { useEffect, useState } from "react";
import { useApp } from "@/state/AppContext";
import { usePageTitle } from "@/lib/usePageTitle";
import { api, rows } from "@/lib/api";
import { localized } from "@/theme/tenantTheme";
import { EventCard } from "@/components/EventCard";

export default function EventsList() {
  const { t, lang, tenant } = useApp();
  usePageTitle(t("events.title")); // RF-21: per-page tab title
  const [events, setEvents] = useState(null);

  useEffect(() => {
    if (!tenant) return;
    setEvents(null);
    api.get("/city/events", { params: { tenant_id: tenant.id, limit: 100 } }).then((r) => setEvents(rows(r.data)));
  }, [tenant]);

  return (
    <div className="mx-auto max-w-7xl px-5 py-12 sm:px-8">
      <h1 className="font-heading text-4xl font-bold tracking-tight sm:text-5xl">{t("events.title")}</h1>
      <p className="mt-2 max-w-2xl text-base text-muted-foreground">
        {t("events.subtitle", { city: localized(lang, tenant, "name") })}
      </p>

      {events === null ? (
        <p className="mt-8 text-center text-muted-foreground">{t("common.loading")}</p>
      ) : events.length === 0 ? (
        <p
          className="mt-6 rounded-2xl border border-dashed border-border p-10 text-center text-muted-foreground"
          data-testid="events-empty"
        >
          {t("common.noResults")}
        </p>
      ) : (
        <>
          <p className="mt-8 text-sm font-medium text-muted-foreground" data-testid="events-result-count">
            {t("events.resultCount", { count: events.length })}
          </p>
          <div className="mt-4 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="events-grid">
            {events.map((e) => (
              <EventCard key={e.id} event={e} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
